export default __webpack_public_path__ + "static/media/logo.287bff6b.svg";